// extracted by mini-css-extract-plugin
export var mainHeader = "header-module--main-header--1tl9t";
export var linkContainer = "header-module--link-container---hUHa";